import NavBar from "../components/NavBar";
import NavButton from "../components/NavButton";
import Footer from "../components/Footer";
import { useNavigate } from "react-router-dom";
import { useState, useEffect } from "react";

function Projects(){
    const navigate = useNavigate();
    const [buttonWidth, setButtonWidth] = useState("25%");
    const [buttonHeight, setButtonHeight] = useState("25%");

    const projects = [
        {
            slug: "project-1",
            title: "Project 1",
            imageSrc: "/img/projects/8/1.jpeg"
        },
        {
            slug: "project-2",
            title: "Project 2",
            imageSrc: "/img/projects/9/1.jpeg"
        },
        {
            slug: "project-3",
            title: "Project 3",
            imageSrc: "/img/projects/4/1.jpeg"
        },
        {
            slug: "project-4",
            title: "Project 4",
            imageSrc: "/img/projects/5/1.png"
        },
        {
            slug: "project-5",
            title: "Project 5",
            imageSrc: "/img/projects/6/1.jpeg"
        },
        {
            slug: "project-6",
            title: "Project 6",
            imageSrc: "/img/projects/7/1.jpeg"
        },
        {
            slug: "project-7",
            title: "Project 7",
            imageSrc: "/img/projects/1/1.jpg"
        },
        {
            slug: "project-8",
            title: "Project 8",
            imageSrc: "/img/projects/2/1.JPG"
        },
        {
            slug: "project-9",
            title: "Project 9",
            imageSrc: "/img/projects/3/1.JPG"
        }
    ];

    useEffect(() => {
        const updateButtonWidth = () => {
            if(window.innerWidth <= 440){
                setButtonWidth("90%");
                setButtonHeight("10rem");
            } else if(window.innerWidth <= 1300){
                setButtonWidth("45%");
                setButtonHeight("25rem");
            } else {
                setButtonWidth("25%");
                setButtonHeight("25rem");
            }
        };

        updateButtonWidth();
        window.addEventListener("resize", updateButtonWidth);
        return () => window.removeEventListener("resize", updateButtonWidth);
    }, [])

    return(
        <div className='page-wrapper gallery-page'>
            <NavBar/>
            <main>
                <h1 style={{textAlign:  'center'}}>Projects</h1>
                <div className='button-grid'>
                    {projects.map((project) => (
                        <NavButton key={project.slug} text={project.title} img={project.imageSrc} link={`/projects/${project.slug}`} width={buttonWidth} height={buttonHeight}/>
                    ))}
                </div>
            </main>
            <Footer/>
        </div>
    )
}
export default Projects;